import { render, staticRenderFns } from "./TeachersOverview.vue?vue&type=template&id=19d9fa4f&"
import script from "./TeachersOverview.vue?vue&type=script&lang=js&"
export * from "./TeachersOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports